import React from 'react';
import { Form } from '../../ui/universe';
import { useMenuStore, useOcrStore } from '../../../store';
import {
  OpenResultRenderer,
  ResultRenderer,
  RequestRenderer,
  ResponseRenderer
} from './renderers';

/**
 * 响应参数组件
 * 根据 type 渲染不同类型的响应内容
 */
function ResponseParams({ type, onSelect }) {
  // 从 store 获取状态
  const detail = useMenuStore((state) => state.currentMenu);
  const request = useOcrStore((state) => state.request);
  const finalResponse = useOcrStore((state) => state.finalResponse);

  const renderParams = () => {
    try {
      switch (type) {
        case 'OpenResult':
          return <OpenResultRenderer onSelect={onSelect} />;

        case 'Result':
          return (
            <ResultRenderer
              resultType={detail?.resultConfig?.type}
              onSelect={onSelect}
            />
          );

        case 'Request':
          return (
            <RequestRenderer
              request={request}
              paramsList={detail?.paramsList}
            />
          );

        case 'Response':
          return <ResponseRenderer response={finalResponse} />;

        default:
          return null;
      }
    } catch {
      return null;
    }
  };

  return (
    <Form layout="horizontal" split>
      {renderParams()}
    </Form>
  );
}

export default ResponseParams;
